export { default as LandingPage } from './LandingPage';


// WEBPACK FOOTER //
// ./src/features/landing-page/index.js